export const CALC_API_DEBOUNCE_DURATION = 500;

export const DATA_STORAGE_KEY = 'GRAWE:react:forms:travel-insurance:data';
export const PAYMENT_STORAGE_KEY = 'GRAWE:react:forms:travel-insurance:payed';

export const DATE_ERROR_MESSAGES = {
  inPast: 'Eingegebenes Datum muss in der Zukunft liegen!',
  beforeStart: 'Reiseende darf nicht vor Reisebeginn liegen.',
  max365daysInFuture: 'Eingegebenes Datum darf maximal 365 Tage in der Zukunft liegen.',
  tooLong: 'Ungültiger Reisezeitraum: maximaler Versicherungszeitraum beträgt 365 Tage'
};

export const MAX_DURATION = 31;

export const CANCELLATION_ERROR_MESSAGES = {
  notToday: `Achtung! Der Stornoschutz wird nicht am Tag der Reisebuchung abgeschlossen.
  Aus diesem Grund sind nur Ereignisse versichert, welche sich ab dem 10. Tag nach Abschluss ereignen.`,
  lateCompletion: `Der Stornoschutz muss am Tag der Reisebuchung oder mindestens 31 Tage vor Reisebeginn abgeschlossen werden.
  Ein späterer Abschluss ist nicht möglich.`
};
